// Branchen für SEO-Landingpages (analog zu Städten)

export const BRANCHEN = {
  hotels: {
    slug: "hotels",
    name: "Hotels",
    nameSingular: "Hotel",
    icon: "Hotel",
    img: "restaurant",
    lead: "Hotels & Beherbergung",
    intro: (loc) =>
      `Hotels haben einen hohen, aber planbaren Energieverbrauch${loc}. Wir beschaffen Strom und Gas transparent, optimieren Ihre Lastprofile und sorgen für kalkulierbare Kosten – damit Sie sich auf Ihre Gäste konzentrieren können.`,
    painpoints: [
      "Hoher Grundlast- und Spitzenverbrauch (Küche, Wellness, Klima)",
      "Auslaufende Verträge und plötzliche Preiserhöhungen",
      "Mehrere Standorte oder Zählpunkte schwer zu überblicken",
    ],
    benefits: [
      "RLM-Analyse für hohen Verbrauch",
      "Kalkulierbare, planbare Energiekosten",
      "Bündelung mehrerer Häuser/Zählpunkte",
      "Persönliche Betreuung statt Callcenter",
    ],
  },
  restaurants: {
    slug: "restaurants",
    name: "Restaurants & Gastronomie",
    nameSingular: "Restaurant",
    icon: "UtensilsCrossed",
    img: "restaurant",
    lead: "Gastronomie",
    intro: (loc) =>
      `In der Gastronomie${loc} entscheidet jeder Cent. Wir prüfen Ihre Strom- und Gasverträge unabhängig und finden günstigere Konditionen – ohne versteckte Klauseln, mit vollem Wechselservice.`,
    painpoints: [
      "Energieintensive Küchen- und Kühltechnik",
      "Schwankende Öffnungszeiten & Lastprofile",
      "Wenig Zeit für Tarifvergleiche im Tagesgeschäft",
    ],
    benefits: [
      "Unabhängiger Strom- & Gasvergleich",
      "Transparente Konditionen ohne Fallstricke",
      "Optimales Timing der Beschaffung",
      "Kompletter Wechselservice",
    ],
  },
  arztpraxen: {
    slug: "arztpraxen",
    name: "Arzt- & Zahnarztpraxen",
    nameSingular: "Praxis",
    icon: "Stethoscope",
    img: "office",
    lead: "Praxen & Gesundheitswesen",
    intro: (loc) =>
      `Praxen${loc} brauchen zuverlässige, planbare Energie für Geräte, Beleuchtung und Klima. Wir optimieren Ihren Tarif unabhängig und übernehmen den Wechsel – diskret und unkompliziert.`,
    painpoints: [
      "Sensible Medizingeräte mit konstantem Verbrauch",
      "Keine Zeit für Bürokratie neben dem Praxisbetrieb",
      "Unklarheit über passende Tarifart (SLP/RLM)",
    ],
    benefits: [
      "Individuelle Tarifanalyse für Praxen",
      "Planbare Kosten für Ihr Team",
      "Diskrete, persönliche Beratung",
      "Wechsel inkl. Kündigung übernommen",
    ],
  },
  hausverwaltungen: {
    slug: "hausverwaltungen",
    name: "Hausverwaltungen & WEG",
    nameSingular: "Hausverwaltung",
    icon: "Building2",
    img: "solarHouse",
    lead: "Hausverwaltungen",
    intro: (loc) =>
      `Für Hausverwaltungen und Eigentümergemeinschaften${loc} bündeln wir viele Zählpunkte in einer Beschaffung. Das spart Zeit, Aufwand und Kosten – bei voller Transparenz gegenüber Eigentümern und Mietern.`,
    painpoints: [
      "Viele Objekte & Allgemeinstrom-Zählpunkte",
      "Aufwändige Einzelverträge und Fristen",
      "Rechtfertigungsdruck gegenüber Eigentümern",
    ],
    benefits: [
      "Bündelung aller Zählpunkte",
      "Transparente Dokumentation für WEG",
      "Rahmenverträge mit klaren Konditionen",
      "Ein Ansprechpartner für alle Objekte",
    ],
  },
  industrie: {
    slug: "industrie",
    name: "Industrie & Produktion",
    nameSingular: "Industriebetrieb",
    icon: "Factory",
    img: "industry",
    lead: "Industrie",
    intro: (loc) =>
      `Produzierende Unternehmen${loc} profitieren von börsennaher Beschaffung über den Spotmarkt – ohne die hohen Risiko- und Spekulationszuschläge des Terminmarkts. Wir analysieren Ihr RLM-Lastprofil individuell.`,
    painpoints: [
      "Sehr hoher Verbrauch mit RLM-Messung",
      "Hohe Spekulationszuschläge im Terminmarkt",
      "Komplexe Lastprofile & Netzentgelte",
    ],
    benefits: [
      "Börsennahe Spotmarkt-Beschaffung",
      "Individuelle RLM-Lastprofilanalyse",
      "Reduzierte Risiko- & Spekulationszuschläge",
      "Strategische Beschaffungsbegleitung",
    ],
  },
  handwerk: {
    slug: "handwerk",
    name: "Handwerksbetriebe",
    nameSingular: "Handwerksbetrieb",
    icon: "Wrench",
    img: "office",
    lead: "Handwerk",
    intro: (loc) =>
      `Handwerksbetriebe${loc} zahlen oft unnötig hohe Energiekosten für Werkstatt und Maschinen. Wir prüfen Ihren Gewerbestrom unabhängig und finden faire, planbare Konditionen.`,
    painpoints: [
      "Energieintensive Maschinen & Werkstatt",
      "Wenig Zeit für Tarifvergleiche",
      "Unsicherheit bei Vertragslaufzeiten",
    ],
    benefits: [
      "Gewerbestrom-Analyse für Betriebe",
      "Faire, planbare Konditionen",
      "Wechselservice ohne Aufwand",
      "Persönliche Beratung",
    ],
  },
};

export const BRANCHEN_LIST = Object.values(BRANCHEN);
export const getBranche = (slug) => BRANCHEN[slug];
